import * as React from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

export default function CustomLocaleTextGrid() {
  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'commodity', headerName: 'Commodity', width: 150 },
    { field: 'price', headerName: 'Price', type: 'number', width: 110 },
    { field: 'quantity', headerName: 'Quantity', type: 'number', width: 110 },
    { field: 'location', headerName: 'Location', width: 160 },
    { field: 'status', headerName: 'Status', width: 120 },
  ];

  const rows = [
    { id: 1, commodity: 'Gold', price: 1800, quantity: 12, location: 'London', status: 'Available' },
    { id: 2, commodity: 'Silver', price: 25, quantity: 100, location: 'New York', status: 'Available' },
    { id: 3, commodity: 'Platinum', price: 950, quantity: 30, location: 'Tokyo', status: 'Unavailable' },
    { id: 4, commodity: 'Palladium', price: 2200, quantity: 50, location: 'Sydney', status: 'Available' },
  ];

  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        localeText={{
          toolbarDensity: 'Size',
          toolbarDensityLabel: 'Size',
          toolbarDensityCompact: 'Small',
          toolbarDensityStandard: 'Medium',
          toolbarDensityComfortable: 'Large',
        }}
        slots={{
          toolbar: GridToolbar,
        }}
      />
    </div>
  );
}
